class GlsService {

    constructor($http, $q, SnackbarService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.SnackbarService = SnackbarService;
    }

    getStatus() {
        const deferred = this.$q.defer();

        this.$http.get(
            '/ajax/gls/status'
        ).then(
            (response) => {
                if (response.data && response.data != '') {
                    deferred.resolve(response.data);
                } else {
                    deferred.resolve([]);
                }
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    getAvailableOptions(postCode) {
        const deferred = this.$q.defer();

        this.$http.get(
            `/ajax/gls/find_services/${postCode.replace('-', '_')}`
        ).then(
            (response) => {
                if (response.data && response.data != '') {
                    deferred.resolve(response.data);
                } else {
                    deferred.resolve([]);
                }
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setNote(note) {
        const deferred = this.$q.defer();

        this.$http.post(
            '/ajax/gls/set_note',
            {note}
        ).then(
            (response) => {
                this.SnackbarService.add('Zapisano notatkę dla firmy kurierskiej GLS', 'success', true, 3000);

                deferred.resolve(note);
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setOption(optionTag, zip, optionName) {
        const services = [optionTag];

        const deferred = this.$q.defer();

        this.$http.post(
            '/ajax/gls/set_services',
            {
                services,
                zip
            }
        ).then(
            (response) => {
                if (response.data == 'error') {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                this.SnackbarService.add(`Ustawiono opcję "${optionName}"`, 'success', true, 3000);

                deferred.resolve(services);
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    clear() {
        const deferred = this.$q.defer();

        this.$http.get(
            `/ajax/gls/clear_services/`,
        ).then(
            (response) => {
                deferred.resolve(true);
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }
}

export default GlsService;